import React from "react";
import {useDispatch} from "react-redux";
import moment from "moment";
import {DeleteModal, ExpandableText, TextToolTip} from "components";
import {Settings} from "fragments";
import {isAdmin, useSecondaryModal} from "utils";
import {AddNotes} from "./addNotes";
import {Svg} from "assets";
import {legsActions} from "store";

const DELETE_ACTION_TYPE = "DELETE_LEG_NOTE";

export const NoteCard = ({item, legId, tripId}) => {
    const dispatch = useDispatch();
    const {openSecondary, closeSecondary} = useSecondaryModal();


    const handleEditNote = (e, toggleMenu) => {
        toggleMenu();
        openSecondary(
            <AddNotes item={item} legId={legId} tripId={tripId}/>,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 1276
            },
        );
    };

    const deleteNote = (e, toggleMenu) => {
        toggleMenu();
        openSecondary(
            <DeleteModal
                handleDelete={() => {
                    dispatch(legsActions.deleteLegNote(legId, item?._id || item?.id, tripId));
                }}
                actionType={DELETE_ACTION_TYPE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove Note ?`}
                handleCancel={closeSecondary}
                afterSuccess={closeSecondary}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    const settingsList = () => [
        {
            Svg: Svg.EditInfoSvg,
            text: "Edit",
            handleClick: handleEditNote,
        },

        {
            Svg: Svg.TrashSvg,
            text: "Delete",
            handleClick: deleteNote,
        },
    ];

    return (
        <div className="note-card-wrapper">
            <div className="note-card-box">
                <div className="note-card-main-info-icon_note">
                    <TextToolTip
                        text={
                            <div className="notes-svg-box">
                                <Svg.NoteSvg/>
                            </div>
                        }
                        content="Note"
                        showTooltip
                        wrapperStyles={{width: "fit-content"}}
                    />

                    {item?.text && <ExpandableText htmlContent={item?.text}/>}
                </div>

                <p className="note-card-main-info-dates">
                    <p
                        className="note-card-main-info-text"
                        style={{whiteSpace: "nowrap"}}
                    >
                        {moment.utc(item?.createdDate).format("MM/DD/YYYY")}
                    </p>

                    <p
                        className="note-card-main-info-text"
                        style={{whiteSpace: "nowrap"}}
                    >
                        {moment(item?.createdDate).format("LT")}
                    </p>

                    {item?.creatorName && (
                        <p
                            className="note-card-main-info-text"
                            style={{whiteSpace: "nowrap"}}
                        >
                            Created by:
                        </p>
                    )}
                    {item?.creatorName && (
                        <TextToolTip
                            classNameText="receivable-note-card-main-info-text"
                            text={`${item?.creatorName}`}
                            content={`${item?.creatorName}`}
                        />
                    )}
                </p>
            </div>

            {isAdmin &&
                <Settings
                    list={settingsList}
                />
            }
        </div>
    );
};
